import React, { useState, useEffect } from 'react';
import styles from '../css/detailCSS.less';
import cx from 'classnames';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { StudyInfoType } from '@/types/camp/study/studentBaseInfoType';
import { NodeStudyState } from '@/types/camp/study/index';
import Editor from '@digit-fe/digit-editor-new';
import DateFormatMin from '@/pages/camp/util/dateFormatMin';
import { ProgressType } from '@/types/camp/details/detailsType';
import { CampStudyState } from '@/types/camp/study';

interface Props {
  studentBaseInfo: StudyInfoType | null;
  nodeProgress: ProgressType | null | undefined;
}

const StudyRight: React.FC<Props> = ({ studentBaseInfo, nodeProgress }) => {
  return (
    <>
      <div className="com_cmap_card_box" style={{ marginBottom: 24 }}>
        <div className={styles.com_cmap_card_info}>
          {studentBaseInfo?.campStudyState &&
          studentBaseInfo?.campStudyState > CampStudyState.NOT_START_LEARNING ? (
            <div style={{ marginBottom: 16 }}>
              <div
                className={cx(styles.com_cmap_card_item, 'flex_1 flex_3')}
                style={{ marginTop: -8 }}
              >
                <span className="f14 col808">我的学分</span>
                <span className="f18 col333 fw600">{studentBaseInfo?.campScore}</span>
              </div>
              <div className={cx(styles.com_cmap_card_item, 'flex_1 flex_3')}>
                <span className="f14 col808">当前排名</span>
                <span>
                  <span className="col333 f18 fw600">{studentBaseInfo?.myRanking}</span>
                  <span style={{ padding: '0 2px' }}>/</span>
                  <span className="f14 col808">{studentBaseInfo?.allStudent}</span>
                </span>
              </div>
              <div className={cx(styles.com_cmap_card_item, 'flex_1 flex_3')}>
                <span className="f14 col808">学习时长</span>
                <span>
                  <DateFormatMin duration={studentBaseInfo?.learningDuration || 0} />
                </span>
              </div>
            </div>
          ) : (
            ''
          )}

          {studentBaseInfo?.camp.finishRule && (
            <div className={styles.closing_requirement}>
              <div style={{ padding: '0 0 6px' }}>打卡成功条件</div>
              {studentBaseInfo?.successConditionList &&
              studentBaseInfo?.successConditionList.length === nodeProgress?.allNode ? (
                <div className="flex_1" style={{ padding: '8px 0', gap: 6 }}>
                  {studentBaseInfo?.successConditionList.filter(
                    (it) => it.studyState === NodeStudyState.NODE_SUCCESS,
                  ).length === nodeProgress?.allNode ? (
                    <CheckCircleOutlined className="f14 col52c" />
                  ) : studentBaseInfo?.successConditionList.some(
                      (item) => item.studyState === NodeStudyState.NODE_FAIL,
                    ) ? (
                    <CloseCircleOutlined className="colff3" />
                  ) : (
                    <span className={styles.inon_gray}></span>
                  )}
                  <span className="col5a5">完成所有打卡节点</span>
                </div>
              ) : (
                <div>
                  {studentBaseInfo?.successConditionList &&
                    studentBaseInfo?.successConditionList.map((item, index) => (
                      <div key={index} className="flex_1" style={{ padding: '8px 0', gap: 6 }}>
                        {item.studyState === NodeStudyState.NODE_SUCCESS ? (
                          <CheckCircleOutlined className="f14 col52c" />
                        ) : item.studyState === NodeStudyState.NODE_FAIL ? (
                          <CloseCircleOutlined className="colff3" />
                        ) : (
                          <span className={styles.inon_gray}></span>
                        )}
                        <span className="col5a5">完成 {item.name}</span>
                      </div>
                    ))}
                </div>
              )}

              {studentBaseInfo?.campStudyState &&
              studentBaseInfo?.campStudyState > CampStudyState.NOT_START_LEARNING ? (
                studentBaseInfo?.camp.finishRule.conditionForSuccess.earnCredits && (
                  <div className="flex_1" style={{ padding: '8px 0', gap: 6 }}>
                    {studentBaseInfo.campScore >=
                    studentBaseInfo?.camp.finishRule.conditionForSuccess.earnCredits ? (
                      <CheckCircleOutlined className="f14 col52c" />
                    ) : (
                      <CloseCircleOutlined className="colff3" />
                    )}
                    <span>
                      学分≥{studentBaseInfo?.camp.finishRule.conditionForSuccess.earnCredits}
                    </span>
                  </div>
                )
              ) : (
                <div className="flex_1" style={{ padding: '8px 0', gap: 6 }}>
                  <span className={styles.inon_gray}></span>
                  <span>
                    学分≥{studentBaseInfo?.camp.finishRule.conditionForSuccess.earnCredits}
                  </span>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      {studentBaseInfo && studentBaseInfo.batch && studentBaseInfo.batch.notice && (
        <div className="com_cmap_card_box com_edit_new" style={{ marginBottom: 24 }}>
          <Editor
            content={studentBaseInfo.batch.notice && JSON.parse(studentBaseInfo.batch.notice)}
            editable={false}
            titleProps={{ showTitle: false }}
            catalogProps={{ showCatalog: false }}
          />
        </div>
      )}
    </>
  );
};
export default StudyRight;
